// Renders the kebab-menu trigger inline in the table cell, but portals the ContextMenu's
// floating panel to document.body so it isn't trapped inside the table's per-cell stacking

import { ContextMenu, ContextMenuItem, Divider, IconButton } from '@volvo/vcdk-react';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import type { IWifiNetworkRow } from '@/service/vpc/types/IWifiConfiguration';

// context (which otherwise causes it to render behind subsequent rows).
const NetworkRowActions: React.FC<{
  row: IWifiNetworkRow;
  onRefresh: () => void;
  onEdit: (row: IWifiNetworkRow) => void;
  onDelete: (row: IWifiNetworkRow) => void;
}> = ({ row, onRefresh, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const [triggerEl, setTriggerEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton ref={setTriggerEl} icon="kebab-menu" size="medium" />
      {triggerEl &&
        createPortal(
          <ContextMenu reference={triggerEl} trigger="click" placement="bottom-end">
            <ContextMenuItem onClick={onRefresh}>
              {t(($) => $.components.modal.add_network_modal.refresh_network)}
            </ContextMenuItem>
            <ContextMenuItem onClick={() => onEdit(row)}>
              {t(($) => $.components.modal.add_network_modal.edit_network)}
            </ContextMenuItem>
            <Divider />
            <ContextMenuItem onClick={() => onDelete(row)}>
              {t(($) => $.components.modal.add_network_modal.remove_network)}
            </ContextMenuItem>
          </ContextMenu>,
          document.body
        )}
    </>
  );
};

export default NetworkRowActions;
